import statusTypes from "../../status-types";
import sourceTypes from "../../source-types";
import propertyTypes from "../../property-types";
import propertyCategories from "../../property-categories";
import transactionTypes from "../../transaction-types";
import leaseTypes from "../../lease-types";
import markets from "../../markets";
import singleTenantSubcategories from "../../single-tenant-subcategories";
import multiTenantSubcategories from "../../multi-tenant-subcategories";
import singleMultiTenantIndustrialSubcategories from "../../single-multi-tenant-industrial-subcategories";
import propertySubcategory from "../../property-subcategories";
import unitedStates from "united-states";
import superUsers from "../../super-users";
import profiles from "../../profiles";
import buyerStatus from "../../buyer-status";
import pipelines from "../../pipelines";
import checkboxTypes from '../../checkbox-types';
import statusTypesFinancing from "../../status-types-financing";
import loanTypes from "../../loan-types";

export const getOptionsType = (optionsType,isFilter) => {
    switch (optionsType) {
        case 'status':
            return statusTypes;
        case 'source':
            return sourceTypes;
        case 'type':
            return propertyTypes;
        case 'category':
            return propertyCategories;
        case 'transaction':
            return transactionTypes;
        case 'lease':
            return leaseTypes;
        case 'market':
            return isFilter ? markets.concat("Empty") : markets;
        case 'subcategorySTNL':
            return singleTenantSubcategories;
        case 'subcategoryMT':
            return multiTenantSubcategories;
        case 'subcategoryIndustrialSTNLMT':
            return singleMultiTenantIndustrialSubcategories;
        case 'propertySubcategory':
            return propertySubcategory;
        case 'states':
            return unitedStates.filter(el => !el.isTerritory);
        case 'superUsers':
            return superUsers;
        case 'profiles':
            return profiles;
        case 'buyerStatus':
            return buyerStatus;
        case 'pipeline':
            return pipelines;
        case 'checkbox':
            return checkboxTypes;
        case 'status-financing':
            return statusTypesFinancing;
        case 'loan':
            return loanTypes;
    }
    return null;
};